import React from "react";
import "./servicesPlan.css";

export default function ServicesPlan() {
  const mountData = (Structure) => {
    sessionStorage.setItem("Mount", Structure);
  };
  return (
    <section id="ServicePlan" className="servicePlan">
      <div className="serviceHead">
        <h1>Solar Panel Cleaning</h1>
        <p>Solar panel cleaning packages to fit everyone's needs</p>
      </div>
      <div className="serviceList">
        <div className="serviceCard">
          <div className="cardContent">
            <h5>Basic Package</h5>
            <p>
              Focus on standard cleaning with a low-pressure water wash,
              suitable for light soiling and regular maintenance.
            </p>
          </div>
        </div>

        <div className="serviceCard" onClick={() => mountData("Trapoziadal")}>
          <div className="cardContent">
            <h5>Standard Package</h5>
            <p>
              Includes the basic cleaning plus manual wiping for stubborn dirt,
              and possibly a mild detergent solution.
            </p>
          </div>
        </div>

        <div className="serviceCard" onClick={() => mountData("Other")}>
          <div className="cardContent">
            <h5>Premium Package</h5>
            <p>
              Offers the most comprehensive cleaning, including specialized
              detergents, bird nest removal, and debris clearing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
